import React from 'react';
import createSvgIcon from './utils/createSvgIcon';

export default createSvgIcon(
  <React.Fragment><path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" /><path fill="none" d="M0 0h24v24H0z" /></React.Fragment>
, 'ExpandLess');
